export const CHIP_SELECTOR_ID = 'chipSelectorId' as const;
export const GANTT_CHART_CONTAINER = 'ganttChartContainer' as const;
export const DROPZONE_ID = 'dropzone' as const;